export enum QuizPlayerKind {
    EXISTING = 0,
    INVITATION = 1,
    GUEST = 2
}